import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.class.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_CLASS_ASYNC: `${uid}.saveClassAsync`,
    SAVE_CLASS_SUCCESS: `${uid}.saveClassSuccess`,
    SAVE_CLASS_FAILURE: `${uid}.saveClassFailure`,
    CREATE_CLASS: `${uid}.createClass`
};

export { ActionTypes };
